import { useQuery } from "@tanstack/react-query";
import { IReward } from "components/ScreenComponent/StartEarningRewardsComponent/StartEarningRewardsComponent";
import { useAppContext } from "contexts";

type FeaturedSiteRewardResponse = {
  items: IReward[];
};

export function useGetFeaturedSiteRewardQuery() {
  const { apiService } = useAppContext();

  return useQuery({
    queryKey: ["site-rewards-featured"],
    queryFn: async (): Promise<FeaturedSiteRewardResponse> => {
      return apiService.get<FeaturedSiteRewardResponse>("/site-rewards/featured");
    },
    retry: 3,
    retryDelay: 1000,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
}
